<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-face-recognition`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 27a8 8 0 017.125 11.642l3.296 3.296a1 1 0 010 1.414l-1.697 1.697a1 1 0 01-1.414 0l-3.19-3.19A8 8 0 1135 27zM7 32a1 1 0 011 1v7h7a1 1 0 011 1v2a1 1 0 01-1 1H7.636C5.628 44 4 42.21 4 40v-7a1 1 0 011-1h2zm28-1a4 4 0 100 8 4 4 0 000-8zm-17-3c0 1.895 2.105 4 6 4v4c-6.105 0-10-3.895-10-8h4zm8-14v10.5a2.5 2.5 0 01-2.336 2.495L23.5 27H21v-4h1v-9h4zm7 0a1 1 0 011 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4a1 1 0 011-1h2zm-16 0a1 1 0 011 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4a1 1 0 011-1h2zM40.364 4C42.372 4 44 5.79 44 8v7a1 1 0 01-1 1h-2a1 1 0 01-1-1V8h-7a1 1 0 01-1-1V5a1 1 0 011-1h7.364zM15 4a1 1 0 011 1v2a1 1 0 01-1 1H8v7a1 1 0 01-1 1H5a1 1 0 01-1-1V8c0-2.21 1.628-4 3.636-4H15z"/></svg>
</template>
<script>

export default {
  name: 'IconFaceRecognition',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
